import { Module } from '../Module';

Module.instance().directive('tbIntegerInputValidator',
  () => {
    return {
      restrict: 'A',
      require: 'ngModel',
       link: (scope: ng.IScope, elm: JQuery, attrs: ng.IAttributes, ctrl: ng.INgModelController) => {
        const INTEGER_REGEXP: RegExp = /^\-?\d+$/;

        ctrl.$parsers.push((inputVal: any) => {
          ctrl.$setValidity('integer', INTEGER_REGEXP.test(inputVal));
          return inputVal;
        });
      }
    };
  }
);
